import { getApi, postApi } from "services/common";
import { ENV_CONFIG } from "environment";

export const msalTokenFetcher = async (appName = 'az') => {
    try {
        let url = ENV_CONFIG.AZURE_MSAL_SERVICE + `?url=${window.location.href}`;
        window.location.href = url;
    } catch (err) {
        throw err;
    }
}

export const redeemSessionToken = async (sessionToken) => {
    return await postApi(ENV_CONFIG.FETCH_NODE_SESSION_TOKEN_SERVICE, {}, {sessionToken: sessionToken});
};

export const mintOauthToken = async (accessToken, idToken, appName) => {
    let appNameConfirm = appName || localStorage.getItem('currentAppName') || 'Brand Assistant BBU';
    return await getApi(ENV_CONFIG.CHAT_ASSISTANT_OAUTH_MINTING_SERVICE, { 
        accesstoken: accessToken, 
        idtoken: idToken,
        appName: appNameConfirm 
    });
}

export const fetchUserDetails = async (accessToken) => {
    return await getApi(ENV_CONFIG.CHAT_ASSISTANT_USER_DETAILS_SERVICE, { accesstoken: accessToken });
}

export const fetchADGroup = async (userId, accessToken) => {
    return await getApi(ENV_CONFIG.CHAT_ASSISTANT_ADGROUP_SERVICE, { accesstoken: accessToken , userid: userId });
}

export const fetchRefreshAccessToken = async (sessionToken) => {
    return await postApi(ENV_CONFIG.FETCH_REFRESH_AZURE_TOKEN_SERVICE, {}, {sessionToken: sessionToken});
}

export const fetchUserAppList = async (prid) => {
    return await getApi(ENV_CONFIG.CHAT_ASSISTANT_FETCH_USER_APP_LIST_SERVICE, { prid: prid });
}

export const loginUser = async (userDetails, prid, appName) => {
    const { displayName, email } = userDetails;
    const [lastName = '', firstName = ''] = displayName.split(',').map(s => s.trim());

    const payload = {
        prid,
        appName,
        firstName,
        lastName,
        email,
        includeAppData: true
    };
    return await postApi(ENV_CONFIG.CHAT_ASSISTANT_LOGIN_USER_SERVICE, {}, payload);
}

export const issueJwtToken = async (accessToken) => {
    return await postApi(ENV_CONFIG.ISSUE_JWT_TOKEN_SERVICE, {}, { accessToken });
}
